import messages from './myDataExport.json' with { type: 'json' };

export const myDataExportEn: Readonly<typeof messages> = messages;
